<template>
  <div class="study-online-tab2" v-if="item_programs.length">
    <p class="title">
      <!-- <span>学习项目</span> -->
      <span>{{ $t("collect.Program") }}</span>
    </p>
    <div class="class-list">
      <itemStudy :list2="item_programs" id="dataList2"></itemStudy>
    </div>
    <!-- <router-link to="/main/learning_camp" tag="p" class="ajax-more">查看更多></router-link> -->
    <router-link to="/main/learning_camp?tabType=0" tag="p" class="ajax-more">{{
      $t("columnVideo.seeMore")
    }}</router-link>
  </div>
</template>
<script>
import itemStudy from "components/learningCamp/itemStudy.vue";
export default {
  name: "StudyOnlineTab2",
  components: {
    itemStudy,
  },
  data() {
    return {
      // item: []
    };
  },
  props: ["programs", "item_programs"],
  methods: {
    // niceData() {
    //   let _this = this;
    //   let url = "index.php/mobile/trainplan-program/my-trainplan-program-list";
    //   let params = {
    //     category_id: 0,
    //     page: 1,
    //     size: 2,
    //     sys_id: localStorage.getItem("_sys_id"),
    //     user_id: localStorage.getItem("_user_data_id"),
    //     company_id: localStorage.getItem("_user_data_company_id"),
    //     sso_token: localStorage.getItem("_user_data_sso_token"),
    //     language: localStorage.getItem("_user_data_language"),
    //     not_start_except: 1,
    //     expire_except: 1
    //   };
    //   _this.$axios.post(url, params).then(function(res) {
    //     if (res.data.code == 0) {
    //       var arr = res.data.result.data;
    //       var message = {};
    //       for (var i = 0; i < arr.length; i++) {
    //         if (arr[i].finish_progress == 100) {
    //           // 已完成
    //           arr[i].message = { whichShow: 1, limitDays: -1, mask: false };
    //         } else if (arr[i].is_overdue == 1) {
    //           // 已过期
    //           arr[i].message = { whichShow: 4, limitDays: -1, mask: true };
    //         } else if (arr[i].left_days > 0 && arr[i].left_days <= 15) {
    //           // 剩
    //           arr[i].message = { whichShow: 3, limitDays: arr[i].left_days };
    //         } else {
    //           // 未完成
    //           arr[i].message = { whichShow: 2, limitDays: -1, mask: false };
    //         }
    //       }
    //       _this.item = arr;
    //     } else {
    //       // //_this.$message.error("数据异常");
    //       //_this.$message.error(_this.$t('public.DataError'));
    //     }
    //   });
    // }
  },
  created() {
    // this.niceData();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.study-online-tab2 {
  width: 100%;
  margin-bottom: 0.22rem;
  background: #fff;

  .title {
    color: #666666;
    height: 0.72rem;
    line-height: 0.72rem;
    font-size: 0.28rem;
    text-align: center;
    background: #fff;
    border-bottom: solid 0.01rem #eee;
    span {
      position: relative;
      &:before {
        .modified-line;
        left: -0.3rem;
      }
      &:after {
        .modified-line;
        right: -0.3rem;
      }
    }
  }
  .class-tabs {
    width: 100%;
    overflow: hidden;
    background: #f6f6f6;
    li {
      width: 50%;
      height: 0.72rem;
      background: #f6f6f6;
      line-height: 0.72rem;
      font-size: 0.32rem;
      text-align: center;
      float: left;
      &.high-light {
        background: #fff;
      }
    }
  }
  .class-list {
    width: 100%;
  }
  .ajax-more {
    height: 0.66rem;
    line-height: 0.66rem;
    text-align: center;
    font-size: 0.22rem;
    color: #005587;
    border-top: 0.01rem solid #d9ddde;
  }
}
.modified-line {
  content: "";
  position: absolute;
  top: 50%;
  width: 0.22rem;
  height: 0.02rem;
  background: #666;
}
</style>
